@if (isLoading) {
<div class="reserve-loading-container">
    <div class="loading-container"></div>
    <span>載入預約資料中．．．</span>
</div>
} @else {
<!-- 最新報告 -->
@if (selectedTab === 0) {
<div class="report-card-content">

    @if (noReportData) {
    <div class="empty-latest-search-result">
        <span>您目前尚無健檢紀錄，或報告資料彙處理中</span>
        <p>完成健檢後，您的數值都會自動記錄在這裡</p>
        <button mat-button class="btn-fill-primary btn-size-l" (click)="navigateHome()">
            <img width="18" height="18" src="assets/img/Only me.png" alt="">
            <app-text size="specialS" weight="m" color="white">回到首頁預約您的專屬健檢</app-text>
        </button>
    </div>

    }
    @else if (this.status === '9') {
    <div class="time-title">
        <app-text size="specialL" weight="m" color="gray-900">{{this.latestReportResponse?.bookDate ?? '' |
            formatDateYearMonthDay}}</app-text>

        <!-- 手機版:下拉選單 -->
        <div class="category-select mobile-only">
            <mat-form-field appearance="fill">
                <mat-select [value]="selectedCategory" (selectionChange)="selectCategory($event.value)">
                    <mat-select-trigger>
                        <div class="select-trigger-content">
                            <span>{{ selectedCategoryName }}</span>
                            @if (selectedCategoryHasAlert) {
                            <span class="alert-dot"></span>
                            }
                        </div>
                    </mat-select-trigger>
                    @for (category of examCategories; track category.examItem) {
                    <mat-option [value]="category.examItem">
                        <div class="select-option-content">
                            <span>{{ category.name }}</span>
                            @if (category.hasAlert) {
                            <span class="alert-dot"></span>
                            }
                        </div>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="report-layout">
        <!-- 左側:檢查分類 -->
        <div class="report-left">
            <!-- 桌面版:分類列表 -->
            <div class="category-title desktop-only">
                <app-text size="category-text" weight="s" color="steel-600">檢查分類</app-text>
            </div>

            <div class="category-list desktop-only">
                @for (category of examCategories; track category.examItem) {
                <div class="category-item" [class.active]="selectedCategory === category.examItem"
                    (click)="selectCategory(category.examItem)">
                    <app-text size="specialS" weight="m" color="gray-700">{{ category.name }}</app-text>
                    @if (category.hasAlert) {
                    <span class="alert-dot"></span>
                    }
                </div>
                }
            </div>
        </div>

        <!-- 右側：檢查項目列表 -->
        <div class="report-right">
            @if (isShowAllCategories) {
            <!-- 顯示所有分類 -->
            @for (category of examCategories; track category.examItem) {
            <div class="category-section">
                <div class="category-header">
                    <app-text size="specialL" weight="l" color="primary-900">{{ category.name }}</app-text>
                </div>

                <div class="exam-list-header">
                    <app-text size="category-text" weight="s" color="gray-600">項目</app-text>
                    <app-text size="category-text" weight="s" color="gray-600">數值</app-text>
                    <app-text size="category-text" weight="s" color="gray-600">參考值 (單位)</app-text>
                </div>

                @for (exam of getCategoryExams(category.examItem); track exam.examItem; let i = $index) {
                <div class="exam-item" [class.odd-row]="i % 2 === 0" [class.has-alert]="exam.isAbnormal">
                    <div class="exam-name">
                        <app-text size="reportItem" weight="m" color="gray-900">{{ exam.name }}</app-text>
                        <app-text size="report-download" weight="s" color="gray-600">{{ exam.nameEn }}</app-text>
                    </div>

                    <!-- 數值欄位：根據 isNum 顯示不同內容 -->
                    <div class="exam-value">
                        @if (exam.isNum) {
                        <app-text size="category-text" weight="m" [color]="exam.isAbnormal ? 'red-500' : 'gray-800'">
                            {{ exam.value }}
                        </app-text>
                        } @else {
                        <button mat-button class="view-detail-btn"
                            (click)="openReportCart(exam); $event.stopPropagation()">
                            <app-text size="report-download" weight="s" color="primary-500">
                                查看詳情
                            </app-text>
                        </button>
                        }
                    </div>

                    <div class="exam-reference">
                        <app-text size="category-text" weight="m" color="gray-600">{{ exam.refData }}</app-text>
                    </div>

                    <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                        <app-text size="report-download" weight="s" color="primary-500">
                            歷年紀錄
                        </app-text>
                    </button>

                    <!-- 2026/05/14 由國泰高館決定先隱藏 -->
                    <!-- @if (exam.isChart) {
                    <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                        <img width="12" height="12" src="assets/img/Line Chart.png" alt="">
                        <app-text size="report-download" weight="s" color="primary-500">
                            趨勢圖
                        </app-text>
                    </button>

                    } @else {
                    <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                        <app-text size="report-download" weight="s" color="primary-500">
                            歷年紀錄
                        </app-text>
                    </button>
                    } -->
                </div>
                }
            </div>
            }
            } @else {
            <!-- 顯示單一分類 -->
            <div class="category-header">
                <app-text size="specialL" weight="l" color="primary-900">{{ selectedCategoryName }}</app-text>
            </div>

            <div class="exam-list-header">
                <app-text size="category-text" weight="s" color="gray-600">項目</app-text>
                <app-text size="category-text" weight="s" color="gray-600">數值</app-text>
                <app-text size="category-text" weight="s" color="gray-600">參考值 (單位)</app-text>
            </div>

            @for (exam of getCategoryExams(selectedCategory); track $index; let i = $index) {
            <div class="exam-item" [class.odd-row]="i % 2 === 0" [class.has-alert]="exam.isAbnormal">
                <div class="exam-name">
                    <app-text size="reportItem" weight="m" color="gray-900">{{ exam.name }}</app-text>
                    <app-text size="report-download" weight="s" color="gray-600">{{ exam.nameEn }}</app-text>
                </div>

                <!-- 數值欄位：根據 isNum 顯示不同內容 -->
                <div class="exam-value">
                    @if (exam.isNum) {
                    <app-text size="category-text" weight="m" [color]="exam.isAbnormal ? 'red-500' : 'gray-800'">
                        {{ exam.value }}
                    </app-text>
                    } @else {
                    <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                        <app-text size="report-download" weight="s" color="primary-500">
                            查看詳情
                        </app-text>
                    </button>
                    }
                </div>

                <div class="exam-reference">
                    <app-text size="category-text" weight="m" color="gray-600">{{ exam.refData }}</app-text>
                </div>

                <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                    <app-text size="report-download" weight="s" color="primary-500">
                        歷年紀錄
                    </app-text>
                </button>

                <!-- 2026/05/14 由國泰高館決定先隱藏 -->
                <!-- @if (exam.isChart) {
                <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                    <img width="12" height="12" src="assets/img/Line Chart.png" alt="">
                    <app-text size="report-download" weight="s" color="primary-500">
                        趨勢圖
                    </app-text>
                </button>

                } @else {
                <button mat-button class="view-detail-btn" (click)="openReportCart(exam); $event.stopPropagation()">
                    <app-text size="report-download" weight="s" color="primary-500">
                        歷年紀錄
                    </app-text>
                </button>
                } -->
            </div>
            }
            }
        </div>
    </div>
    } @else {
        <div class="empty-search-result">
            <span>您目前報告資料處理中</span>
            <p>完成健檢後，您的檢查報告將於 14–21 個工作日內完成，</p>
            <p>數值結果會自動同步至此頁面，方便您隨時查閱。</p>
        </div>
    }
</div>

<!-- 遮罩層 -->
<div class="overlay" [class.active]="isReportCartOpen" (click)="toggleReportCart()"></div>

<!-- 歷年健檢紀錄側邊欄 -->
<div class="report-left-cart" #reportLeftCart>

    <!-- 關閉按鈕 -->
    <div class="report-left-cart-header">
        <button mat-button class="btn-icon-close" (click)="toggleReportCart()">
            <img width="32" height="32" src="assets/img/i-close.svg" alt="" />
        </button>
    </div>

    <!-- 歷年紀錄內容 -->
    <div class="report-left-cart-body">

        <!-- 歷年數據列表 -->
        @if (selectedExamForHistory?.isChart) {

        }

        <div class="header-block">
            <!-- 若是數值 -->
            @if (selectedExamForHistory?.isNum) {
            <div>
                <app-text size="category-text" weight="l" color="gray-800">
                    {{ selectedExamForHistory?.name || '檢項名稱' }}
                </app-text>
            </div>
            @if (selectedExamForHistory?.refData !== '') {
                <div>
                    <app-text size="report-download" weight="s" color="gray-600">
                        參考值 (單位):　{{ selectedExamForHistory?.refData }}
                    </app-text>
                </div>
                <div>
                    <app-text size="report-download" weight="s" color="gray-500">
                        參考值來源依照衛福部最新指引
                    </app-text>
                </div>
            }
            <!-- <div class="chart-container">
                <app-kendo [historicalExamRecords]="historicalExamRecords"
                    [refData]="selectedExamForHistory?.refData"></app-kendo>
            </div> -->
            }
            <!--若是文字  -->
            @else {
            <div>
                <app-text size="category-text" weight="l" color="gray-800">
                    {{ selectedExamForHistory?.name || '檢項名稱' }}
                </app-text>
            </div>
            }
        </div>

        <!-- 健檢日期 -->
        <div class="report-list">
            <div class="header-title">
                <app-text size="reportTitle" weight="l" color="gray-700">健檢結果</app-text>
                @if (selectedExamForHistory?.isNum) {
                <app-text size="reportTitle" weight="l" color="gray-700">數值</app-text>
                }
            </div>
            @for (record of historicalExamRecords; track record.bookDate) {
            @if (selectedExamForHistory?.isNum) {
            <div class="report-item">
                <div class="report-date">
                    <app-text size="m" weight="m">{{ record.bookDate | formatDateYearMonthDay }}</app-text>
                </div>
                <div class="report-status">
                    @for (result of record.resultList; track $index) {
                    <app-text size="category-text" weight="m"
                        [color]="result.warnFlag === '1' ? 'red-500' : (result.rValue ? 'gray-800' : 'gray-400')">
                        {{ result.rValue || '本次未檢查' }}
                    </app-text>
                    }
                </div>
            </div>
            } @else {
            <div class="report-item-noData">
                <div class="report-date">
                    <app-text size="m" weight="m">{{ record.bookDate | formatDateYearMonthDay }}</app-text>
                </div>
                <div class="report-status">
                    @for (result of record.resultList; track $index) {
                    <app-text size="category-text" weight="m"
                        [color]="result.warnFlag === '1' ? 'red-500' : (result.rValue ? 'gray-800' : 'gray-400')">
                        {{ result.rValue || '本次未檢查' }}
                    </app-text>
                    }
                </div>
            </div>
            }
            }
        </div>
    </div>
</div>
}
<!-- 歷年健檢報告 -->
@else {
@if (noData) {
<div class="empty-search-result">
    <span>目前無可下載的報告，如有疑問請洽客服。</span>
    <p>若您尚未有本院健檢紀錄，或健檢時間已超過 5 年，則不提供線上下載</p>
</div>
}
@else {
<div class="report-card-content">
    <div class="page-subtitle-block">
        <img width="24" height="24" src="assets/img/Health-book.png" alt="" />
        <div>
            <p class="subTitle-main"> 歷次報告下載範圍限近 5 年內 </p>
            <p class="subTitle-secondary">如需查詢更早的紀錄，請來電與我們聯繫。</p>
        </div>
    </div>

    <!-- 歷年健檢側欄與數值 -->
    <div class="report-list">
        <div class="header-title">
            <app-text size="reportTitle" weight="l" color="gray-700">健檢日期</app-text>
            <app-text size="reportTitle" weight="l" color="gray-700">報告狀態</app-text>
        </div>
        @for (report of paginatedReports; track report.caseNo) {
        <div class="report-item">
            <div class="report-date">
                <app-text size="m" weight="m">{{ report.bookDate | formatDateYearMonthDay }}</app-text>
            </div>
            <div class="report-status">
                @if (report.bookStatus === '1' || report.bookStatus === '3') {
                <app-text size="s" weight="m" [style.color]="'#a3a3a3'">報告尚未出爐</app-text>
                } @else if (report.bookStatus === '8' || report.bookStatus === '9') {
                <button mat-button (click)="downloadReport(report.caseNo)">
                    <img src="assets/img/i-download.svg" alt="下載" width="24" height="24" />
                </button>
                } @else {
                <app-text size="s" weight="m" [style.color]="'#a3a3a3'">處理中</app-text>
                }
            </div>
        </div>
        }
    </div>

    <!-- 分頁控制 -->
    @if (totalPages > 1) {
    <div class="pagination">
        <button mat-button (click)="previousPage()" [disabled]="currentPage === 1">
            <img src="assets/img/i-arrow-left.svg" alt="" width="26" height="26" />
        </button>

        @for (page of displayPages; track page) {
        @if (page === '...') {
        <span class="pagination-ellipsis">...</span>
        } @else {
        <button mat-button [class.active]="page === currentPage" (click)="goToPage(page)">
            {{ page }}
        </button>
        }
        }

        <button mat-button (click)="nextPage()" [disabled]="currentPage === totalPages">
            <img src="assets/img/i-arrow-right.svg" alt="" width="26" height="26" />
        </button>
    </div>
    }
</div>
}
}
}
